import React from 'react';

import { Tooltip } from '@makemydeal/dr-ui-bricks-components';

import type { SideNavViewItem } from '../../types/showroomNavTypes';
import { NavItemWithTooltip } from '../SideBarNav/sideBarNav.style';

/**
 * Wraps a nav item's control with its config-driven tooltip.
 *
 * The tooltip is surfaced only while the item is disabled, to explain why it is
 * unavailable (e.g. Manage Documents requires a vehicle) — so an item that is enabled
 * or has no tooltip renders its control untouched. The ui-bricks Tooltip is an
 * info-icon revealed on hover, so it sits next to the control (outside the disabled
 * button, which is otherwise inert to pointers) rather than wrapping it.
 */
const NavItemTooltip: React.FC<{ item: SideNavViewItem; children: React.ReactNode }> = ({ item, children }) => {
    const disabled = !item.clickAction.canExecute;

    if (!disabled || !item.tooltip) {
        return <>{children}</>;
    }

    return (
        <NavItemWithTooltip data-testid={`showroom-nav-item-${item.key}-tooltip`}>
            {children}
            <Tooltip placement="top">{item.tooltip}</Tooltip>
        </NavItemWithTooltip>
    );
};

export default NavItemTooltip;
